import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import type { Dispatch, ReactElement, SetStateAction } from 'react';

import { RoutePath } from '@components/AppRouter/constants';

import type { Route } from '../../AppRouter/types';

import styles from './GroupItem.module.scss';

interface GroupItemProps {
  route: Route;
  setHoverLinks: Dispatch<SetStateAction<Route[]>>;
}

export const GroupItem = observer(
  ({
    route: { path, title = '', link, active, key, onClick, routes },
    setHoverLinks,
  }: GroupItemProps): ReactElement | null => {
    const isActive = Boolean((path && title) || active || !!routes);

    const count = useMemo(() => routes?.filter((el) => !el.hidden).length, [routes]);

    // Необходимо для открытия головной организации
    const pathWithState = useMemo(
      () =>
        path?.includes(RoutePath.ORGANIZATION_CARD) ? { pathname: path, state: { head: true } } : { pathname: path },
      [path],
    );

    const item = useMemo(() => {
      if (key === 'token' || path === 'logout') {
        return <a onClick={onClick}>{title}</a>;
      }

      if (isActive) {
        return link ? (
          <a href={path} target="_blank" rel="noreferrer">
            {title ?? ''}
          </a>
        ) : (
          <>
            <Link to={pathWithState}>{title}</Link>
            {count && <span className={styles.count}>{count}</span>}
          </>
        );
      }

      return title;
    }, [count, isActive, key, link, onClick, path, pathWithState, title]);

    return (
      <li
        className={classnames([styles.item], { [styles.notActive]: !isActive, [styles.withCount]: count })}
        onMouseEnter={routes && count ? () => setHoverLinks(routes) : undefined}
      >
        {item}
      </li>
    );
  },
);
